import { render, staticRenderFns } from "./dashboard-cards.vue?vue&type=template&id=0249e65e&scoped=true"
import script from "./dashboard-cards.vue?vue&type=script&lang=js"
export * from "./dashboard-cards.vue?vue&type=script&lang=js"
import style0 from "./dashboard-cards.vue?vue&type=style&index=0&id=0249e65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0249e65e",
  null
  
)

export default component.exports